import {Component, inject, OnInit} from '@angular/core'
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card'
import {BankIdComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {SpbAccessibleLinkDirective} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../../../environments/environment'
import {ConfigService} from '../../services/config.service'
import {filter} from 'rxjs'
import {Router} from '@angular/router'

@Component({
  selector: 'spb-login',
  templateUrl: './login.component.html',
  imports: [
    BankIdComponent,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    SpbAccessibleLinkDirective
  ],
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  public bankIdUrl = environment.authServiceUrl
  public domain = environment.domain

  public configService = inject(ConfigService)

  private readonly router = inject(Router)

  public ngOnInit(): void {
    this.configService.accessToken$
      .pipe(filter(Boolean))
      .subscribe(() => {
        this.router.navigate(['/', 'fyll-i', '1'], ).then()
      })
  }
}
